var ajaxPromise,
	pathArray = location.href.split('/'),
	protocol = pathArray[0],
	host = pathArray[2],
	ajax_url = protocol + '//' + host + '/wp-admin/admin-ajax.php';

$('body').on('input change', '.postcode_validate input', function() {
    var postcode = $(this).val();

    if (postcode.length === 5) {

        $('.m__form').addClass('loading');
        $('.m__form__loading').addClass('active');

        var animPromise, result;
        ajaxPromise = $.ajax({
            type: 'POST',
            url: ajax_url,
            dataType: 'json',
            data: ({
                'action': 'ajax_form_filter',
                'postcode': postcode
            }),
            success: function (data) {
                result = data.options_html; 
            }
        });
        $.when(animPromise, ajaxPromise).done(function () {
            $('.postcode_locations select').html(result);
            $('.m__form').removeClass('loading'); 
            $('.m__form__loading').removeClass('active'); 
            $('.postcode_locations').addClass('active');
        });
    }
});

jQuery(document).on('gform_post_render', function(event, formId) {
    if (jQuery('.postcode_validate').length) {
        var postcode = $('.postcode_validate input').val();
        var location_input = $('.postcode_locations_input input').val();

        if (postcode.length === 5) {
    
            var animPromise, result;
            ajaxPromise = $.ajax({
                type: 'POST',
                url: ajax_url,
                dataType: 'json',
                data: ({
                    'action': 'ajax_form_filter',
                    'postcode': postcode
                }),
                success: function (data) {
                    result = data.options_html; 
                }
            });
            $.when(animPromise, ajaxPromise).done(function () {
                $('.postcode_locations select').html(result); 
                $('.postcode_locations').addClass('active');

                if (location_input) {
                    jQuery('.postcode_locations select option').each(function() {
                        if (jQuery(this).val() === location_input) {
                            jQuery(this).prop('selected', true);
                            return false;
                        }
                    });
                }else{
                    jQuery('.postcode_locations').addClass('gfield_error');
                    jQuery('.postcode_locations').append('<div id="validation_message_4_29" class="gfield_description validation_message gfield_validation_message">This field is required.</div>')
                }

                jQuery('.postcode_locations select').trigger('change');
            });
        }
    }
});